<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="vid"
    class="w-100">
    <BaseTextFieldGroup
      :value="_value"
      :type="type"
      :name="name"
      :label="label"
      :errors="[...errors, ...responseFieldErrors]"
      :error-text-color="errorTextColor"
      :placeholder="placeholder"
      :disabled="disabled"
      :col="col"
      :empty-str-to-null="emptyStrToNull"
      v-on="$listeners">
      <template #fieldPrepend>
        <slot name="fieldPrepend" />
      </template>
      <template #labelSuffix>
        <slot name="labelSuffix" />
      </template>
    </BaseTextFieldGroup>
  </ValidationProvider>
</template>

<script>
import BaseTextFieldGroup from './BaseTextFieldGroup.vue'
import get from 'lodash/get'
export default {
  components: {
    BaseTextFieldGroup
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    col: {
      type: [String, Number],
      default: 12
    },
    type: {
      type: String,
      default: 'text' 
    },
    name: {
      type: String,
      default: undefined
    },
    rules: {
      type: [String, Array],
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    responseErrors: {
      type: Object,
      default: null
    },
    errorTextColor: {
      type: String,
      default: 'primary'
    },
    vid: {
      type: String,
      default: null
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    responseFieldErrors() {
      return get(this.responseErrors, this.vid) || []
    }
  }
}
</script>

<style>

</style>